import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useGameAdditionalInfo } from '../hooks';
import { formatToDisplay } from '../../../../../utils/bonus';

const centrifugoLimitsFormatter = (limits) => {
  if (!limits) {
    return null;
  }
  const [sums, currency] = limits.split(' ');
  return (
    sums
      .split('-')
      .map((amount) => formatToDisplay(Number(amount), 0))
      .join('—') +
    ' ' +
    currency
  );
};

const GameCardBets = ({ className, gameId }) => {
  const centrifugoInfo = useGameAdditionalInfo(gameId);

  return useMemo(() => {
    if (!centrifugoInfo?.limits) {
      return null;
    }

    return (
      <span className={className}>
        {centrifugoLimitsFormatter(centrifugoInfo?.limits)}
      </span>
    );
  }, [className, centrifugoInfo]);
};

GameCardBets.propTypes = {
  className: PropTypes.string,
  gameId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default GameCardBets;
